import React from 'react';
import { createPortal } from 'react-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { siteConfig } from '../data/site';

const WHATSAPP_MESSAGE = encodeURIComponent(
  'Olá! Gostaria de solicitar um orçamento para desenvolvimento de site institucional.'
);

const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${WHATSAPP_MESSAGE}`;

const WhatsAppFloat = () =>
  createPortal(
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-[99999] flex h-14 w-14 min-h-[3.5rem] min-w-[3.5rem] shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#25D366] text-white shadow-lg md:h-16 md:w-16 md:min-h-[4rem] md:min-w-[4rem]"
      style={{
        bottom: 'max(1.25rem, env(safe-area-inset-bottom, 0px))',
        right: 'max(1.25rem, env(safe-area-inset-right, 0px))',
      }}
      aria-label="Contato via WhatsApp"
      data-cursor="pointer"
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366] opacity-20 animate-ping" />
      <FaWhatsapp className="relative z-10 shrink-0 text-2xl md:text-3xl" />
    </a>,
    document.body
  );

export default WhatsAppFloat;
